import dealRefundMiddleware from '../middleware/dealRefund';
import dealDisputeResolveMiddleware from '../middleware/dealDisputeResolve';

export default [
  {
    path: '/deal/refund',
    name: 'deal.refund',
    meta: {
      requiresAuth: true,
      middleware: [
        dealRefundMiddleware,
      ],
    },
  },
  {
    path: '/deal/dispute/resolve',
    name: 'deal.dispute.resolve',
    meta: {
      requiresAuth: true,
      middleware: [
        dealDisputeResolveMiddleware,
      ],
    },
  },
];
